/**
 * Defines an action that can be executed
 */
export type Action = () => any;
